import type { RtlItem } from '../../config-provider/src/internal-interface'
import rtlStyle from '../src/styles/rtl.cssr'

export const tagRtl: RtlItem = {
  name: 'Tag',
  style: rtlStyle
}
